import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import { UsageType } from 'models/automation/Common';
import ManageLanguagesModal from './ManageLanguagesModal';

export const MANAGE_LANGUAGES_MODAL_ID = 'manage-languages-modal';

/**
 * This hook should be used for Automation templates.
 * In the future, we may abstract it to be used across the entire application with other pages;
 *
 * It uses the `useFetchTemplateSettings` hook to fetch the template settings based on the usage type.
 */
const useManageLanguagesModal = ({
  usageType,
  hideAutoTranslation,
}: {
  usageType: UsageType;
  hideAutoTranslation?: boolean;
}) => {
  const { openModal } = useAppModal();
  const { t } = useTranslation();

  const openManageLanguagesModal = () => {
    openModal({
      customContent: (
        <ManageLanguagesModal
          usageType={usageType}
          hideAutoTranslation={hideAutoTranslation}
        />
      ),
      id: MANAGE_LANGUAGES_MODAL_ID,
      title: t('pageAutomations.common.manageLanguagesModal.title'),
    });
  };

  return {
    openManageLanguagesModal,
  };
};

export default useManageLanguagesModal;
